import { UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { Automation } from 'features/Automations/types';
import { automationQueries } from 'queryKeys/automations';
import AutomationsAPI from 'api/automationsAPI';
import { EmailTemplate } from 'components/ReferenceModal/types';
import emailTemplatesAPI from 'api/emailTemplatesAPI';
import districtAPI from 'api/districtAPI';
import { UserBasic } from 'types/user';
import ReferenceTemplateListAPI from 'api/referenceTemplateListAPI';
import { ReferenceTemplate } from 'types/application';

export const useQueryGetAutomationsListData = (
  roleId: number,
  options?: Omit<UseQueryOptions<Automation[], AxiosError>, 'queryKey' | 'queryFn'>
): UseQueryResult<Automation[], AxiosError> => {
  return useQuery({
    queryKey: automationQueries.automations.list(roleId).queryKey,
    queryFn: () => {
      return AutomationsAPI.getAutomations(roleId!);
    },
    enabled: roleId !== undefined && roleId !== null,
    networkMode: 'always',
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...options,
  });
};

export const useQueryGetEmailTemplateListData = (
  userId: number
): UseQueryResult<EmailTemplate[], AxiosError> => {
  return useQuery({
    queryKey: automationQueries.automations.emailTemplateList(userId).queryKey,
    queryFn: () => {
      return emailTemplatesAPI.getEmailTemplatesForAutomations().then((res) => res);
    },
  });
};

export const useQueryGetSuperAndDistrictAdminsData = (
  districtId: number
): UseQueryResult<UserBasic[], AxiosError> => {
  return useQuery({
    queryKey: automationQueries.automations.superAndDistrictAdminList(districtId).queryKey,
    queryFn: () => {
      return districtAPI.getDistrictAndSuperAdmins(districtId).then((res) => res);
    },
  });
};

export const useQueryGetReferenceTemplateListData = (
  districtId: number
): UseQueryResult<ReferenceTemplate[], AxiosError> => {
  return useQuery({
    queryKey: automationQueries.automations.referenceTemplateList(districtId).queryKey,
    queryFn: () => {
      return ReferenceTemplateListAPI.fetchReferences().then((res) => res);
    },
  });
};
